import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useInterviewContext } from '../../context/interview_context';
import { useQuickInsightContext } from '../../context/quick_insights_context';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import NoArticlesFound from '../../components/reusable/NoArticlesFound';
import ToolTip from '../../common/Tooltip/ToolTip';
import { slugify } from '../../utils';
import { ORDERS_PER_PAGE, QUESTIONS } from '../../constants';
import Image from '../../common/footer/Images/Image';
import { useOrderContext } from '../../context/order_context';
import OrderTwo from '../../components/Orders/OrderTwo';
import OrderTable from '../../components/Orders/OrderTable';
import PaginationOne from '../../components/pagination/PaginationOne';

function UserDetailTab() {

    //Reading state from store
    const { loginData } = useSelector((item) => item?.user);
    const { interviewSeries, seriesInteractionByUser, getSeriesInteractionByUser } = useInterviewContext();
    const { quickInsights, insightsUserInteraction } = useQuickInsightContext();
    const { orders, fetchOrders, orderLoading, ordersError } = useOrderContext();

    // Property initialization
    const { id } = useParams();

    const navigate = useNavigate();
    const location = useLocation();

    // Orders Constants
    const orderData = orders && orders.length > 0 ? JSON.parse(JSON.stringify(orders)) : null;
    const dataStatus = orderData?.map((order) =>
        order?.status === "created"
            ? "Pending"
            : order?.status === "authorized"
                ? "Paid"
                : order?.status || ""
    );

    const pendingOrders = orders ? orders.filter(item => item.status === "created") : [];
    const paidOrders = orders ? orders.filter(item => item.status === "authorized") : [];

    // State variable initialization
    const [contentTab, setContentTab] = useState('liked');
    const [currentItems, setCurrentItems] = useState([]);
    const [initialPage, setInitialPage] = useState(0);
    const [activeTab, setActiveTab] = useState(dataStatus?.some((status) => status === "Pending") ? "pending" : "paid");

    // Extracting login user's data
    const currentMember = loginData && loginData?.data && loginData?.data;
    // const currentMember = "6a92bcbac8f04e2a6167a865";

    // Constants for pagination
    const itemsPerPage = ORDERS_PER_PAGE;
    const data = activeTab === "paid" ? paidOrders : pendingOrders;
    // Data sorting
    const sortedData = [...data].sort(
        (a, b) =>
            new Date(b?.createdAt) - new Date(a?.createdAt)
    );
    const userUniqueId = currentMember && currentMember?.firebaseUid ? currentMember?.firebaseUid : currentMember?.userRecordId;
    const currentUserOrders = (sortedData || [])?.filter((item) => item?.customerId === userUniqueId);
    const pageCount = Math.ceil((currentUserOrders || [])?.length / itemsPerPage);

    // All series
    const seriesList =
        interviewSeries && interviewSeries?.length ? interviewSeries : [];

    const filteredSeriesByBookmark = seriesList.filter(items =>
        seriesInteractionByUser?.some(i => i?.seriesId === items?.slug && i?.isBookmarked === true && i?.userId === id)
    );

    const filteredSeriesByLike = seriesList.filter(items =>
        seriesInteractionByUser?.some(i => i?.seriesId === items?.slug && i?.isLiked === true && i?.userId === id)
    );

    const filteredSeriesBySave = seriesList.filter(items =>
        seriesInteractionByUser?.some(i => i?.seriesId === items?.slug && i?.isSaved === true && i?.userId === id)
    );

    // All Quick-Insights
    const quickInsightList = quickInsights && quickInsights?.length ? quickInsights : [];

    const filteredInsightsByBookmark = quickInsightList.filter(items =>
        insightsUserInteraction?.some(i => i?.insightId === items?.id && i?.isBookmarked === true && i?.userId === id)
    );

    const filteredInsightsByLike = quickInsightList.filter(items =>
        insightsUserInteraction?.some(i => i?.insightId === items?.id && i?.isLiked === true && i?.userId === id)
    );

    const filteredInsightsByUpvote = quickInsightList.filter(items =>
        insightsUserInteraction?.some(i => i?.insightId === items?.id && i?.isUpvoted === true && i?.userId === id)
    );

    // All TabData
    const likedTabData = [...(filteredSeriesByLike || []), ...(filteredInsightsByLike || [])];
    const bookmarkedTabData = [...(filteredSeriesByBookmark || []), ...(filteredInsightsByBookmark || [])];
    const savedTabData = [...(filteredSeriesBySave || [])];
    const upvotedTabData = [...(filteredInsightsByUpvote || [])];

    // Function for handle Tab
    const handleTab = (content) => {
        try {
            if (content === 'liked') {
                setContentTab('liked');
            } else if (content === 'bookmarked') {
                setContentTab('bookmarked');
            } else if (content === 'saved') {
                setContentTab('saved');
            }
            else if (content === 'upvoted') {
                setContentTab('upvoted');
            }
            else if (content === 'orders') {
                setContentTab('orders');
            }
        } catch (error) {
            console.log("86 : UserDetailTab : Error in handleTab", error);
        }
    }

    // Function for handleFilter
    const handleFilter = (plan) => {
        try {
            if (plan === 'pending') {
                setActiveTab('pending');
            } else {
                setActiveTab('paid');
            }
        } catch (error) {
            console.log("123 : UserDetailTab : Error in handleFilter : ", error && JSON.stringify(error));
        }
    };
    // Constant functions
    const handlePageClick = (event) => {
        try {
            const selectedPage = event?.selected || 0;
            setInitialPage(selectedPage);
            window.scrollTo({ top: 0, behavior: "smooth" });
            handlePageGeneration(selectedPage);
        } catch (error) {
            console.log("133 : UserDetailTab : Error while changing page :: ", error);
            throw error;
        }
    };

    const handlePageGeneration = (page) => {
        try {
            const startOffset = page * itemsPerPage;
            const endOffset = startOffset + itemsPerPage;
            const newItems = (currentUserOrders || []).slice(
                startOffset,
                endOffset
            );
            setCurrentItems(newItems);
        } catch (error) {
            console.log(
                "UserDetailTab : Error while generating page :: ",
                error
            );
        }

    };

    // handlling pagination & redirects
    useEffect(() => {
        if (orderLoading) return;

        if (!currentMember?.userId) {
            navigate('/', { replace: true });
            return;
        }
        setInitialPage(0);
        handlePageGeneration(0);
    }, [orders, orderLoading, currentMember?.userId]);

    useEffect(() => {

        // TODO: Problamatic code
        // if (currentMember && currentMember?.userId) {
        //     const userUniqueId = currentMember && ((currentMember?.firebaseUid ? currentMember?.firebaseUid : currentMember?.userRecordId));

        //     fetchOrders(userUniqueId);
        // }

        // constants for pageItems
        const pageItems = (currentUserOrders || []).slice(0, itemsPerPage);
        setCurrentItems(pageItems);

        // Optional: Reset page back to 0 when tabs are switched
        setInitialPage(0);

    }, [activeTab, orders, itemsPerPage]);

    useEffect(() => {
        if (id) {
            getSeriesInteractionByUser(id);
        }
    }, []);


    useEffect(() => {
        //  Get hash from URL
        const hash = location.hash;

        if (hash) {
            const tabName = hash.replace('#', '');
            if (tabName) {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth' // Use 'auto' for an instant jump instead of smooth scrolling
                });
                setContentTab(tabName);
            }
        }
    }, []);

    return (
        <div>
            <div className='col-12 y-gap-30 mt--20'>
                {/* TABS */}
                <div className="course-details-content">
                    {/* Display Tab after md */}
                    <ul className="edu-course-tab d-flex gap-5 ps-4 justify-content-start nav nav-tabs d-none d-md-flex" role="tablist">
                        <li className="nav-item mx-0">
                            <button
                                className={contentTab === 'liked' ? 'nav-link active' : 'nav-link'}
                                type="button"
                                aria-label="Liked"
                                onClick={() => handleTab('liked')}
                            >
                                Liked
                            </button>
                        </li>
                        <li className="nav-item mx-0">
                            <button
                                className={contentTab === 'bookmarked' ? 'nav-link active' : 'nav-link'}
                                type="button"
                                aria-label="Bookmarked"
                                onClick={() => handleTab('bookmarked')}
                            >
                                Bookmarked
                            </button>
                        </li>
                        <li className="nav-item mx-0">
                            <button
                                className={contentTab === 'saved' ? 'nav-link active' : 'nav-link'}
                                type="button"
                                aria-label="Saved"
                                onClick={() => handleTab('saved')}
                            >
                                Saved
                            </button>
                        </li>
                        <li className="nav-item mx-0">
                            <button
                                className={contentTab === 'upvoted' ? 'nav-link active' : 'nav-link'}
                                type="button"
                                aria-label="Upvoted"
                                onClick={() => handleTab('upvoted')}
                            >
                                Upvoted
                            </button>
                        </li>
                        <li className="nav-item mx-0">
                            <button
                                className={contentTab === 'orders' ? 'nav-link active' : 'nav-link'}
                                type="button"
                                aria-label="Orders"
                                onClick={() => handleTab('orders')}
                            >
                                Orders
                            </button>
                        </li>
                    </ul>

                    {/* Display Tab under md */}
                    <div className="tabs -side js-tabs d-flex d-md-none">
                        <div className="tabs__controls js-tabs-controls text-start">
                            <div>
                                <a
                                    onClick={() => handleTab('liked')}
                                    className={`tabs__button text-dark js-tabs-button ${contentTab === "liked" ? "is-active-2" : ""
                                        } `}
                                    type="button"
                                >
                                    Liked
                                </a>
                            </div>

                            <div>
                                <a
                                    onClick={() => handleTab('bookmarked')}
                                    className={`tabs__button text-dark js-tabs-button ${contentTab === "bookmarked" ? "is-active-2" : ""
                                        } `}
                                    type="button"
                                >
                                    Bookmarked
                                </a>
                            </div>
                            <div>
                                <a
                                    onClick={() => handleTab('saved')}
                                    className={`tabs__button text-dark js-tabs-button ${contentTab === "saved" ? "is-active-2" : ""
                                        } `}
                                    type="button"
                                >
                                    Saved
                                </a>
                            </div>

                            <div>
                                <a
                                    onClick={() => handleTab('upvoted')}
                                    className={`tabs__button text-dark js-tabs-button ${contentTab === "upvoted" ? "is-active-2" : ""
                                        } `}
                                    type="button"
                                >
                                    Upvoted
                                </a>
                            </div>

                            <div>
                                <a
                                    onClick={() => handleTab('orders')}
                                    className={`tabs__button text-dark js-tabs-button ${contentTab === "orders" ? "is-active-2" : ""
                                        } `}
                                    type="button"
                                >
                                    Orders
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="tab-content px-3">
                        {contentTab === 'liked' &&
                            <div className={`tab-pane fade show ${contentTab === 'liked' ? 'active' : ''} `}>
                                <div className="course-tab-content">
                                    {(likedTabData || [])?.length ?
                                        <>
                                            <div className="row">
                                                {filteredSeriesByLike && filteredSeriesByLike?.length ?
                                                    <div class={`col-12 edu-blog-widget-2 widget-latest-post`}>
                                                        <div class="inner">
                                                            <div className="section-title text-start">
                                                                <h5 className='pre-title fs-17'>Series Liked by you</h5>
                                                            </div>
                                                            <div className='row'>
                                                                {filteredSeriesByLike?.map((elm, i) => (
                                                                    <div class="col-12 col-lg-6 content latest-post-list p-3" key={i}>
                                                                        <div class="d-flex align-items-center latest-post">
                                                                            <div class="thumbnail">
                                                                                <a class="d-block related-series-image"
                                                                                    href={
                                                                                        process.env.PUBLIC_URL +
                                                                                        `/interview-questions/${elm?.categoryId}/${elm?.slug}`
                                                                                    }
                                                                                >
                                                                                    <Image src={elm?.thumbnail} alt="Thumbnail" fill />
                                                                                </a>
                                                                            </div>
                                                                            <div class="post-content text-start">
                                                                                <ToolTip title={elm?.name}>
                                                                                    <h6 class="title truncate-2-lines fs-15 mb-0">
                                                                                        <a class="d-block" href={
                                                                                            process.env.PUBLIC_URL +
                                                                                            `/interview-questions/${elm?.categoryId}/${elm?.slug}`
                                                                                        }
                                                                                        // onClick={() => handleClick(elm)}
                                                                                        >
                                                                                            {elm?.name}
                                                                                        </a>
                                                                                    </h6>
                                                                                </ToolTip>
                                                                                <ul class="blog-meta">
                                                                                    <li className='fs-14'>{elm?.questionCount} {QUESTIONS}</li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    :
                                                    <></>
                                                }
                                            </div>

                                            <div className="row mt--20">
                                                {filteredInsightsByLike && filteredInsightsByLike?.length ?
                                                    <div class={`col-12 edu-blog-widget-2 widget-latest-post`}>
                                                        <div class="inner">
                                                            <div className="section-title text-start">
                                                                <h5 className='pre-title fs-17'>Quick Insights Liked by you</h5>
                                                            </div>
                                                            <div className='row'>
                                                                {filteredInsightsByLike?.map((elm, i) => (
                                                                    <div class="col-12 col-lg-6 content latest-post-list p-3" key={i}>
                                                                        <div class="d-flex align-items-center latest-post">
                                                                            <div class="thumbnail">
                                                                                <div class="d-block quick-insight-img"
                                                                                >
                                                                                    <Image src="/images/quick-insight/Salesforce_Quick_Insight.jpg" alt="Thumbnail" fill />
                                                                                </div>
                                                                            </div>
                                                                            <div class="post-content text-start">
                                                                                <ToolTip title={elm?.title}>
                                                                                    <h6 class="title truncate-1-lines fs-15 mb-0">
                                                                                        <a class="d-block" href={
                                                                                            process.env.PUBLIC_URL +
                                                                                            `/salesforce-quick-insights/${slugify(elm?.title)}`
                                                                                        }
                                                                                        // onClick={() => handleClick(elm)}
                                                                                        >
                                                                                            {elm?.title}
                                                                                        </a>
                                                                                    </h6>
                                                                                </ToolTip>
                                                                                <ul class="blog-meta">
                                                                                    <li className="fs-14">{elm?.readingTime}</li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    :
                                                    <></>
                                                }
                                            </div>
                                        </>
                                        :
                                        <>
                                            <NoArticlesFound text="liked" articlePath='/' />
                                        </>
                                    }
                                </div>
                            </div>
                        }

                        {contentTab === 'bookmarked' &&
                            <div className={`tab-pane fade show ${contentTab === 'bookmarked' ? 'active' : ''} `}>
                                <div className="course-tab-content">
                                    {(bookmarkedTabData || [])?.length ?
                                        <>
                                            <div>
                                                {filteredSeriesByBookmark && filteredSeriesByBookmark?.length ?
                                                    <div class={`edu-blog-widget-2 widget-latest-post`}>
                                                        <div class="inner">
                                                            <div className="section-title text-start">
                                                                <h5 className='pre-title fs-17'>Series Bookmarked by you</h5>
                                                            </div>
                                                            <div className='row'>
                                                                {filteredSeriesByBookmark?.map((elm, i) => (
                                                                    <div class="col-12 col-lg-6 content latest-post-list p-3" key={i}>
                                                                        <div class="d-flex align-items-center latest-post">
                                                                            <div class="thumbnail">
                                                                                <a class="d-block related-series-image"
                                                                                    href={
                                                                                        process.env.PUBLIC_URL +
                                                                                        `/interview-questions/${elm?.categoryId}/${elm?.slug}`
                                                                                    }
                                                                                >
                                                                                    <Image src={elm?.thumbnail} alt="Thumbnail" fill />
                                                                                </a>
                                                                            </div>
                                                                            <div class="post-content text-start">
                                                                                <ToolTip title={elm?.name}>
                                                                                    <h6 class="title truncate-2-lines fs-15 mb-0">
                                                                                        <a class="d-block" href={
                                                                                            process.env.PUBLIC_URL +
                                                                                            `/interview-questions/${elm?.categoryId}/${elm?.slug}`
                                                                                        }
                                                                                        // onClick={() => handleClick(elm)}
                                                                                        >
                                                                                            {elm?.name}
                                                                                        </a>
                                                                                    </h6>
                                                                                </ToolTip>
                                                                                <ul class="blog-meta">
                                                                                    <li className="fs-14">{elm?.questionCount} {QUESTIONS}</li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    :
                                                    <></>
                                                }
                                            </div>

                                            <div className="row mt--20">
                                                {filteredInsightsByBookmark && filteredInsightsByBookmark?.length ?
                                                    <div class={`col-12 edu-blog-widget-2 widget-latest-post`}>
                                                        <div class="inner">
                                                            <div className="section-title text-start">
                                                                <h5 className='pre-title fs-17'>Quick Insights Bookmarked by you</h5>
                                                            </div>
                                                            <div className='row'>
                                                                {filteredInsightsByBookmark?.map((elm, i) => (
                                                                    <div class="col-12 col-lg-6 content latest-post-list p-3" key={i}>
                                                                        <div class="d-flex align-items-center latest-post">
                                                                            <div class="thumbnail">
                                                                                <div class="d-block quick-insight-img"
                                                                                >
                                                                                    <Image src="/images/quick-insight/Salesforce_Quick_Insight.jpg" alt="Thumbnail" fill />
                                                                                </div>
                                                                            </div>
                                                                            <div class="post-content text-start">
                                                                                <ToolTip title={elm?.title}>
                                                                                    <h6 class="title truncate-1-lines fs-15 mb-0">
                                                                                        <a class="d-block" href={
                                                                                            process.env.PUBLIC_URL +
                                                                                            `/salesforce-quick-insights/${slugify(elm?.title)}`
                                                                                        }
                                                                                        // onClick={() => handleClick(elm)}
                                                                                        >
                                                                                            {elm?.title}
                                                                                        </a>
                                                                                    </h6>
                                                                                </ToolTip>
                                                                                <ul class="blog-meta">
                                                                                    <li className="fs-14">{elm?.readingTime}</li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    :
                                                    <></>
                                                }
                                            </div>
                                        </>
                                        :
                                        <>
                                            <NoArticlesFound text="bookmarked" articlePath='/' />
                                        </>
                                    }
                                </div>
                            </div>
                        }

                        {contentTab === 'saved' &&
                            <div className={`tab-pane fade show ${contentTab === 'saved' ? 'active' : ''} `}>
                                <div className="course-tab-content">
                                    {(savedTabData || [])?.length ?
                                        <div>
                                            {filteredSeriesBySave && filteredSeriesBySave?.length ?
                                                <div class={`edu-blog-widget-2 widget-latest-post`}>
                                                    <div class="inner">
                                                        <div className="section-title text-start">
                                                            <h5 className='pre-title fs-17'>Series Saved by you</h5>
                                                        </div>
                                                        <div className='row'>
                                                            {filteredSeriesBySave?.map((elm, i) => (
                                                                <div class="col-12 col-lg-6 content latest-post-list p-3" key={i}>
                                                                    <div class="d-flex align-items-center latest-post">
                                                                        <div class="thumbnail">
                                                                            <a class="d-block related-series-image"
                                                                                href={
                                                                                    process.env.PUBLIC_URL +
                                                                                    `/interview-questions/${elm?.categoryId}/${elm?.slug}`
                                                                                }
                                                                            >
                                                                                <Image src={elm?.thumbnail} alt="Thumbnail" fill />
                                                                            </a>
                                                                        </div>
                                                                        <div class="post-content text-start">
                                                                            <ToolTip title={elm?.name}>
                                                                                <h6 class="title truncate-2-lines fs-15 mb-0">
                                                                                    <a class="d-block" href={
                                                                                        process.env.PUBLIC_URL +
                                                                                        `/interview-questions/${elm?.categoryId}/${elm?.slug}`
                                                                                    }
                                                                                    // onClick={() => handleClick(elm)}
                                                                                    >
                                                                                        {elm?.name}
                                                                                    </a>
                                                                                </h6>
                                                                            </ToolTip>
                                                                            <ul class="blog-meta">
                                                                                <li className="fs-14">{elm?.questionCount} {QUESTIONS}</li>
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                <></>
                                            }
                                        </div>
                                        :
                                        <>
                                            <NoArticlesFound text="saved" articlePath='/' />
                                        </>
                                    }
                                </div>
                            </div>
                        }


                        {contentTab === 'upvoted' &&
                            <div className={`tab-pane fade show ${contentTab === 'upvoted' ? 'active' : ''} `}>
                                <div className="course-tab-content">
                                    {(upvotedTabData || [])?.length ?
                                        <div>
                                            {filteredInsightsByUpvote && filteredInsightsByUpvote?.length ?
                                                <div class={`col-12 edu-blog-widget-2 widget-latest-post`}>
                                                    <div class="inner">
                                                        <div className="section-title text-start">
                                                            <h5 className='pre-title fs-17'>Quick Insights Upvoted by you</h5>
                                                        </div>
                                                        <div className='row'>
                                                            {filteredInsightsByUpvote?.map((elm, i) => (
                                                                <div class="col-12 col-lg-6 content latest-post-list p-3" key={i}>
                                                                    <div class="d-flex align-items-center latest-post">
                                                                        <div class="thumbnail">
                                                                            <div class="d-block quick-insight-img"
                                                                            >
                                                                                <Image src="/images/quick-insight/Salesforce_Quick_Insight.jpg" alt="Thumbnail" fill />
                                                                            </div>
                                                                        </div>
                                                                        <div class="post-content text-start">
                                                                            <ToolTip title={elm?.title}>
                                                                                <h6 class="title truncate-1-lines fs-15 mb-0">
                                                                                    <a class="d-block" href={
                                                                                        process.env.PUBLIC_URL +
                                                                                        `/salesforce-quick-insights/${slugify(elm?.title)}`
                                                                                    }
                                                                                    // onClick={() => handleClick(elm)}
                                                                                    >
                                                                                        {elm?.title}
                                                                                    </a>
                                                                                </h6>
                                                                            </ToolTip>
                                                                            <ul class="blog-meta">
                                                                                <li className="fs-14">{elm?.readingTime}</li>
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                <></>
                                            }
                                        </div>
                                        :
                                        <>
                                            <NoArticlesFound text="upvoted" articlePath='/' />
                                        </>
                                    }
                                </div>
                            </div>
                        }

                        {contentTab === 'orders' &&
                            <div className={`tab-pane fade show ${contentTab === 'orders' ? 'active' : ''} `}>
                                <div className="course-tab-content">

                                    {(orders || [])?.length ?
                                        <>
                                            <div className="row g-5">
                                                <div className="col-12 col-lg-6">
                                                    <div className="section-title text-start">
                                                        <span className="pre-title fs-10">Your Orders</span>
                                                        <h3 className="title fs-20 mb--10">Purchase History</h3>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-lg-6">
                                                    <div className="pricing-billing-duration">
                                                        <ul>
                                                            <li className="nav-item">
                                                                <button
                                                                    className={activeTab === 'paid' ? 'nav-link active' : 'nav-link'}
                                                                    type="button"
                                                                    aria-label="paid"
                                                                    onClick={() => handleFilter('paid')}
                                                                >
                                                                    Completed
                                                                </button>
                                                            </li>
                                                            <li className="nav-item">
                                                                <button
                                                                    className={activeTab === 'pending' ? 'nav-link active' : 'nav-link'}
                                                                    type="button"
                                                                    aria-label="pending"
                                                                    onClick={() => handleFilter('pending')}
                                                                >
                                                                    Pending
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                            <OrderTable
                                                orders={currentItems}
                                                member={currentMember}
                                                error={ordersError}
                                            />

                                        </>
                                        :
                                        <>
                                            <NoArticlesFound text="orders" articlePath='/our-resources/paid' />
                                        </>
                                    }
                                </div>

                                <div className="row">
                                    <div className="col-lg-12 mt--60">
                                        <PaginationOne itemsPerPage={itemsPerPage || 10} pageCount={pageCount} initialPage={initialPage} onCurrentItemsChange={handlePageClick} />
                                    </div>
                                </div>
                            </div>
                        }

                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserDetailTab
